import { motion } from "framer-motion";
import { useContext } from "react";
import styled from "styled-components";
import { MenuOpenContext } from "../../context/MenuOpenContext";
import { Box } from "../Box";
import { DelayLink } from "../DelayLink";
import { ReactComponent as ExploreSvg } from "../../assets/svg/museum.svg";
import { useMatch, useResolvedPath } from "react-router-dom";
import { useLocation } from "react-use";

interface NavItemProps {
  to: string;
}

const Indicator = styled(motion(Box))`
  position: absolute;
  left: 0;
  height: 64px;
  width: 64px;
  background-color: ${({ theme }) => theme.colors.blueDark};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  // transform: translateY(-50%);

  svg {
    width: 50%;
    height: 50%;
  }
`;

export const NavItem: React.FC<NavItemProps> = ({ to, children }) => {
  const resolved = useResolvedPath(to);
  const location = useLocation();
  const match = useMatch({
    path: resolved.pathname,
    end: !location.pathname?.includes("themes"),
  });
  const { setMenuOpen } = useContext(MenuOpenContext);

  return (
    <Box fontSize={[6, null, null, 8]} pl={80}>
      {match && (
        <Indicator top={[-16, null, null, -10]}>
          <ExploreSvg />
        </Indicator>
      )}
      <DelayLink
        to={to}
        onDelayStart={() => setMenuOpen(false)}
        delay={0.6 * 1000}
      >
        {children}
      </DelayLink>
    </Box>
  );
};
